import { render } from "./VuetablePaginationDropdown.vue?vue&type=template&id=0fd02a74"
import script from "./VuetablePaginationDropdown.vue?vue&type=script&lang=js"
export * from "./VuetablePaginationDropdown.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__